__turbopack_context__.v({
  "citationHighlighted": "Paragraph-module-scss-module__GBk0IG__citationHighlighted",
  "paragraphwrapper": "Paragraph-module-scss-module__GBk0IG__paragraphwrapper",
});
